import { useEffect } from "react";
import { useParams } from "react-router-dom";

/** Hands a read-only preview token to this tab only, then boots the app as the client. */
export default function ClientPreview() {
  const { token } = useParams();

  useEffect(() => {
    sessionStorage.setItem("asthetik_preview_token", token);
    window.location.replace("/");
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-fog" data-testid="client-preview-boot">
      Opening the client view…
    </div>
  );
}
